  const NavLinks = [
    { id: 'home', text: 'Home', href: '#home-section' },
    { id: 'about', text: 'About', href: '#about-section' },
    { id: 'services', text: 'Services', href: '#services-section' },
    { id: 'faq', text: 'FAQ', href: '#faq-section' },
    { id: 'contact', text: 'Contact', href: '#contact-section' },
  ];


  export default NavLinks;